import { Avatar } from "@mui/material";

const rankStyles = {
  1: { color: "#FFD700", fontColor: "#000000", borderColor: "gold" },
  2: { color: "#C0C0C0", fontColor: "#000000", borderColor: "silver" },
  3: { color: "#CD7F32", fontColor: "#FFFFFF", borderColor: "bronze" },
  4: { color: "#EEEEEE", fontColor: "#000000", borderColor: "#EEEEEE" }
};

export const RankIcon = ({ rank, children }: { rank: number; children: React.ReactNode }) => {
  const rankStyle = rankStyles[rank as keyof typeof rankStyles] || rankStyles[4];
  return (
    <Avatar sx={{ width: 24,
      height: 24,
      pt: 0.25,
      fontSize: "0.8rem",
      fontWeight: 400,
      backgroundColor: rankStyle.color,
      color: rankStyle.fontColor,
      border: `1px solid ${rankStyle.borderColor}` }
    }>
      {children}
    </Avatar>
  );
};
